import { Reducer } from 'redux';

import { ApiExchange } from 'api/types';
// import { Chains } from './exchangeActiveChainUtils';

// Actions

export const changeExchangeInfo = (
  info: ApiExchange,
  // Volume currently does support only those 2 chains - add new manually (Footer calculation)
  chain: 'katanaEVMChain'
) => ({
  type: 'CHANGE_EXCHANGE_INFO' as const,
  chain,
  payload: info,
});

type ExchangeInfoAction = ReturnType<typeof changeExchangeInfo>;

// Reducer

/**
 * Static information about contracts, minimums etc.
 * For dynamic data see "exchangeInfoStats"
 */
type ExchangeInfo = {
  /** Deposit exchange contract addresses on Polygon network */
  // readonly polygonExchangeContractAddress?: string;

  // readonly custodyContractAddress?: string;

  // readonly makerFeeRate?: string;
  // readonly takerFeeRate?: string;

  // readonly makerTradeMinimum?: string;
  readonly defaultMakerFeeRate?: string;
  readonly defaultTakerFeeRate?: string;
  // readonly withdrawalMinimum?: string;
  /** Number of blocks for transaction to be considered confirmed */
  readonly depositEnabled?: boolean;
  readonly withdrawEnabled?: boolean;

  vaultCreationFee?: string;
  vaultCreationMinimum?: string;
  vaultDepositFee?: string;
  vaultDepositMinimum?: string;
  vaultWithdrawalFee?: string;
  vaultWithdrawalMinimum?: string;

  // TODO: katana api add back
  // readonly blockConfirmationDelay?: number;
};

export const exchangeInfoReducer: Reducer<ExchangeInfo, ExchangeInfoAction> = (
  state: ExchangeInfo = {
    depositEnabled: undefined,
    withdrawEnabled: undefined,
  },
  action
): ExchangeInfo => {
  switch (action.type) {
    case 'CHANGE_EXCHANGE_INFO': {
      const {
        // withdrawalMinimum,
        defaultTakerFeeRate,
        defaultMakerFeeRate,
        // makerTradeMinimum,
        // takerTradeMinimum,
        // custodyContractAddress,
        // depositContractAddress,
        // blockConfirmationDelay,
        depositEnabled,
        withdrawEnabled,
      } = action.payload;

      const newState: ExchangeInfo = {
        ...state,
        defaultTakerFeeRate,
        defaultMakerFeeRate,
        // makerTradeMinimum,
        // takerTradeMinimum,
        // withdrawalMinimum,
        // polygonExchangeContractAddress: depositContractAddress,
        // blockConfirmationDelay,
        depositEnabled,
        withdrawEnabled,

        // vaultCreationFee: vaults.vaultCreationFee,
        // vaultCreationMinimum: vaults.vaultCreationMinimum,
        // vaultDepositFee: vaults.vaultDepositFee,
        // vaultDepositMinimum: vaults.vaultDepositMinimum,
        // vaultWithdrawalFee: vaults.vaultWithdrawalFee,
        // vaultWithdrawalMinimum: vaults.vaultWithdrawalMinimum,
      };
      if (JSON.stringify(newState) === JSON.stringify(state)) {
        return state;
      }
      return newState;
    }
    default:
      return state;
  }
};
